import {
  AfterContentInit,
  Component,
  Input,
  Output,
  OnInit,
  ViewChild,
  EventEmitter
} from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { HttpService } from "../../../../core";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { ArPreviewDialogComponent } from "./ar-preview-dialog/ar-preview-dialog.component";
import { EditFloorplanDialogComponent } from "./edit-floorplan-dialog/edit-floorplan-dialog.component";
import { ConnectPropertyDialogComponent } from "./connect-property-dialog/connect-property-dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { ImagePreviewComponent } from "src/app/shared/components/dialog/image-preview/image-preview.component";
import { MatGridList } from "@angular/material/grid-list";
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import { DeleteConfirmDialogComponent } from "./delete-confirm-dialog/delete-confirm-dialog.component";

@Component({
  selector: "app-detail-floorplans",
  templateUrl: "./floorplans.component.html",
  styleUrls: ["./floorplans.component.scss"],
})
export class FloorplansComponent implements OnInit, AfterContentInit {
  @Input() project: any;
  @Output() resetInit = new EventEmitter<string>();

  @ViewChild("childTabs") childTabs: MatTabGroup;
  @ViewChild("grid") grid: MatGridList;

  keywords = "";
  filterBedRoom = "";
  filterBathRoom = "";
  floorPlans = [];

  properties = [];
  // floorplan  关联的 properties
  floorPlanProperties = [];
  // floorplan 详情
  floorPlan: any;
  bedRoom: any;
  bathRoom: any;

  viewDetail = false;
  displayedColumns = ["unit", "config", "building", "price", "status"];

  gridByBreakpoint = {
    xl: 5,
    lg: 5,
    md: 4,
    sm: 3,
    xs: 2,
  };
  gridCol: number;
  layout = "grid";
  selected = "any";
  selectList: any[] = [
    "any",
    "Highest floor",
    "Lowest floor",
    "floor 0 - 10",
    "floor 11 - 20",
    "floor 21 - 30",
    "floor 31 - 40",
    "floor 41 - 50",
  ];

  constructor(
    private httpService: HttpService,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private mediaObserver: MediaObserver
  ) {}

  ngOnInit(): void {
    this.floorPlans = this.project.floorPlans || [];

    // 获取所有 building  的 properties
    if (this.project.buildings && this.project.buildings.length) {
      this.properties = this.project.buildings
        .map((building) => {
          return building.properties ? building.properties : [];
        })
        .reduce((a, b) => a.concat(b));
    }
  }

  ngAfterContentInit() {
    this.mediaObserver.asObservable().subscribe((change: MediaChange[]) => {
      this.gridCol = this.gridByBreakpoint[change[0].mqAlias];
    });
  }

  getImageUrl(fileName: string, project?: any) {
    const projectCode = project
      ? project.projectCode
      : this.project.projectCode;
    return (
      environment.SERVER_URL +
      "images/" +
      projectCode +
      "/floor_plans/" +
      fileName
    );
  }

  // 搜索
  filterData() {
    this.floorPlans = this.project.floorPlans.filter((floorPlan) => {
      if (
        !floorPlan.notes.toLowerCase().includes(this.keywords.toLowerCase())
      ) {
        return false;
      }

      if (this.filterBedRoom && floorPlan.bedRoom != this.filterBedRoom) {
        return false;
      }

      if (this.filterBathRoom && floorPlan.bathRoom != this.filterBathRoom) {
        return false;
      }

      return true;
    });
  }

  // floorplan 详情
  viewFloorPlan(floorPlan) {
    this.floorPlan = floorPlan;
    this.floorPlanProperties = this.properties.filter((property) => {
      return property.floorPlan && property.floorPlan.id === floorPlan.id;
    });
    console.log(this.floorPlanProperties);
    this.viewDetail = true;
  }

  resetFloorplan() {
    if (this.floorPlan) {
      this.closeFloorPlan();
    }
  }

  closeFloorPlan() {
    this.floorPlan = null;
    this.viewDetail = false;
  }

  openImagePreviewDialog() {
    if (!this.floorPlan.images || !this.floorPlan.images.length) {
      return;
    }

    const images = [];
    this.floorPlan.images.map((image) => {
      images.push({
        src: this.getImageUrl(image.fileName, this.project),
      });
    });

    this.dialog.open(ImagePreviewComponent, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      height: "100%",
      width: "100%",
      data: {
        images: images,
      },
    });
  }

  // ar 预览 dialog, ios(usdz) not support preview now
  openArPreviewDialog(canPreview) {
    this.dialog.open(ArPreviewDialogComponent, {
      width: "500px",
      height: canPreview ? "500px" : "100px",
      data: {
        floorPlan: this.floorPlan,
        project: this.project,
        canPreview,
      },
    });
  }

  // 修改 / 创建 floorplan
  openEditFloorPlanDialog(isEdit = false, step = 0) {
    const dialogRef = this.dialog.open(EditFloorplanDialogComponent, {
      width: "650px",
      height: "auto",
      autoFocus: false,
      data: {
        floorPlan: this.floorPlan,
        project: this.project,
        isEdit: isEdit, // 是否是修改
        step: step,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log("afterClosed---",result);
    
      if(!result) {
        return
      }

      const floorPlan = result.floorPlan;
      if (!isEdit) {
        if (!this.project.floorPlans) {
          this.project.floorPlans = [];
        }
        this.project.floorPlans.unshift(floorPlan);
      } else {
        this.project.floorPlans = this.project.floorPlans.map((f) => {
          if (f.id === floorPlan.id) {
            if(floorPlan.notes) {
              f.notes = floorPlan.notes
            }
            return floorPlan;
          }
          return f;
        });
      }

      this.filterData();
    });
    // 创建成功，添加数据
    // if (!isEdit) {
    //   dialogRef.componentInstance.onCreate.subscribe((data) => {
    //     const floorPlan = data.floorPlan;

    //     if (!this.project.floorPlans) {
    //       this.project.floorPlans = [];
    //     }
    //     this.project.floorPlans.unshift(floorPlan);

    //     this.filterData();
    //   });
    // }

    // // 更新成功，修改floorplan 数据
    // dialogRef.componentInstance.onUpdate.subscribe((data) => {
    //   console.log("onUpdate---", data);
    //   const floorPlan = data.floorPlan;

    //   this.project.floorPlans = this.project.floorPlans.map((f) => {
    //     if (f.id === floorPlan.id) {
    //       return floorPlan;
    //     }
    //     return f;
    //   });

    //   this.filterData();
    // });
  }

  // 关联property
  openConnectPropertyDialog() {
    const dialogRef = this.dialog.open(ConnectPropertyDialogComponent, {
      width: "1000px",
      data: {
        floorPlan: this.floorPlan,
        project: this.project,
        properties: this.properties,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.resetInit.emit()
      console.log(result);
      if (result && result.floorPlan) {
        this.project.buildings.forEach((building) => {
          building.properties = building.properties.map((property) => {
            if (result.propertyIds.includes(property.id)) {
              property.floorPlan = result.floorPlan;
            } else if (
              property.floorPlan &&
              property.floorPlan.id === result.floorPlan.id
            ) {
              property.floorPlan = null;
            }
            return property;
          });
        });

        this.floorPlanProperties = this.properties.filter((property) => {
          return (
            property.floorPlan && property.floorPlan.id === result.floorPlan.id
          );
        });
      }
    });
  }

  // 删除确认
  openDeleteConfirmDialog() {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: "400px",
      data: { floorPlan: this.floorPlan, project: this.project },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("openDeleteConfirmDialog-closed");
      if (result && result.floorPlan) {
        this.project.floorPlans = this.project.floorPlans.filter((f) => {
          return f.id !== this.floorPlan.id;
        });

        this.filterData();
        this.closeFloorPlan();
      }
    });
  }
}
